import React, { Component } from 'react';
import { Container,
 Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem } from 'reactstrap';

 import { Link } from 'react-router'

import '../styles/navbar.css'
import logo from '../../assets/images/logo.png'
import logores from '../../assets/images/logores.png'

import Dash from 'react-icons/lib/fa/dashboard'
import Tache from 'react-icons/lib/fa/calendar-plus-o'
import Reporting from 'react-icons/lib/fa/list-alt'

import FaGroup from 'react-icons/lib/fa/group'
import Biblio from 'react-icons/lib/md/format-list-bulleted'
import Portrait from 'react-icons/lib/md/portrait'



import TacheIcon from 'react-icons/lib/ti/calender-outline'
import PrestaIcon from 'react-icons/lib/ti/contacts'
import BiblioIcon from 'react-icons/lib/ti/clipboard'
import Biblio2Icon from 'react-icons/lib/ti/document-text'
import LeadIcon from 'react-icons/lib/ti/group-outline'
import LeadIcon2 from 'react-icons/lib/ti/group'

class NavBar extends Component {

	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.state = {
			isOpen: false
		};
		// console.log(this.props.params)
		// console.log(this.props.params.regionParam)

	}

	toggle() {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}


	renderProvider(){

		return(
			<Collapse isOpen={this.state.isOpen} navbar>
	            <Nav className="ml-left" navbar>

	              <NavItem>
	                <Link to="/prestataire/fiche" activeClassName="activeLink">Ma fiche</Link>
	              </NavItem>
                  {/*
	              <NavItem>
	                <Link to="/prestataire/documents" activeClassName="activeLink">Bibliothèque de documents</Link>
	              </NavItem>
	              */}
	            </Nav>
	        </Collapse>
		)
	}

	// +(this.props.params.regionParam ? '/'+this.props.params.regionParam : '')}

	renderManager(){
		return(
			<Collapse isOpen={this.state.isOpen} navbar>
	            <Nav className="ml-left" navbar>

	              <NavItem>
	                <Link to={"/manager/dashboard"} activeClassName="activeLink"> <Dash /> Tableau de bord</Link>
	              </NavItem>

	              <NavItem>
	                <Link to={"/manager/leads"} activeClassName="activeLink">  <LeadIcon /> Candidatures</Link>
	              </NavItem>

	              <NavItem>
	                <Link to={"/manager/prestataires"} activeClassName="activeLink"> <PrestaIcon /> Prestataires</Link>
	              </NavItem>

	              <NavItem>
	                <Link to={"/manager/tasks"} activeClassName="activeLink"> <TacheIcon /> Tâches</Link>
	              </NavItem>

	            </Nav>
	        </Collapse>
		)
	}

    render() {

    	const { user } = this.props;

        return (
        	<div className="navbar-container header-navbar">
	            <Container >

	                 <Navbar light toggleable>
				          <NavbarToggler right onClick={this.toggle} />

				          <Link to="/" className="navbar-logo">
				          		<img alt="" src={logo} className="logo-full" />
				          		<img alt="" src={logores} className="logo-res" />
				          	</Link>


				          {user.role === "provider" &&
				          	this.renderProvider()
				      	  }

				      	  {user.role === "manager" &&
				          	this.renderManager()
				      	  }

				      	  {user.role === "superadmin" &&
				          	this.renderManager()
				      	  }

				          <Collapse isOpen={this.state.isOpen} navbar>
				            <Nav className="ml-auto" navbar>
				              <NavItem>
				                 <a onClick={() => this.props.logoutUser()} className="logout">Se déconnecter</a>
				              </NavItem>
				            </Nav>
				          </Collapse>


			        </Navbar>

	            </Container>
	        </div>
        )
    }
}

export default NavBar



// WEBPACK FOOTER //
// ./src/core/components/NavBar.js